import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { ActionButton } from '../../../../components/ActionButton';

export const StyledLanguageContainer = styled.div`
  position: relative;
  margin: 24px 16px;
`;

export const StyledLanguageTitle = styled.p`
  margin: 4px 0;
  ${setFontVariant('caption', colorsPalettes.carbon[500])};
`;

export const StyledLanguageActionButton = styled(ActionButton)`
  width: 100%;
  justify-content: space-between;
`;
